export default __webpack_public_path__ + "static/media/Room8.2f6ef3c7.png";